import PropTypes from "prop-types";
import CategoryHeaderMedia from "../CategoryHeaderMedia";
import CategoryHeaderCopy from "./CategoryHeaderCopy";
import { VIDEO_HEADER } from "../constants";
import { getHeaderTitle } from "../CategoryHeader/helpers";
import styles from "./CategoryHeaderHero.css";
import getMediaUrls from "./getMediaUrls";
import getMediaType from "./getMediaType";
import Icon from "../Icon";

const CategoryHeaderHero = ({ category, viewportCategory, isComingSoon }) => {
  const {
    headerTitle,
    friendlyName,
    headerHtmlEncoded,
    loyaltyBenefit,
    featuredHeader
  } = category;
  const header = getHeaderTitle({
    headerTitle,
    friendlyName,
    headerHtmlEncoded
  });

  const mediaUrls = getMediaUrls(featuredHeader);
  const mediaType = getMediaType({ viewportCategory, mediaUrls });

  return (
    <div id={VIDEO_HEADER} className={styles.heroHeader}>
      <div className={styles.heroHeaderContainer}>
        <CategoryHeaderMedia
          mediaType={mediaType}
          viewportCategory={viewportCategory}
          featuredHeaderData={featuredHeader}
        />
      </div>
      <div className={styles.asosWorldLogoContainer}>
        <Icon icon="asos-world" className={styles.asosWorldLogo} />
      </div>
      <CategoryHeaderCopy
        header={header}
        isComingSoon={isComingSoon}
        endDate={loyaltyBenefit.endDate}
        viewportCategory={viewportCategory}
      ></CategoryHeaderCopy>
    </div>
  );
};

CategoryHeaderHero.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number,
    headerBody: PropTypes.string,
    friendlyName: PropTypes.string,
    headerHtmlEncoded: PropTypes.string,
    headerTitle: PropTypes.string,
    featuredHeader: PropTypes.object,
    loyaltyBenefit: PropTypes.shape({
      endDate: PropTypes.string.isRequired
    })
  }).isRequired,
  viewportCategory: PropTypes.string.isRequired,
  isComingSoon: PropTypes.bool
};

export default CategoryHeaderHero;
